import { Component } from '@angular/core'

const start = `pnpm start [project-name]
example:
pnpm start se-add-person`
const startAll = `pnpm dev-server`
const startDev = `pnpm start:dev [project-name]
example:
pnpm start:dev se-add-person`
const startWatch = `pnpm dev-server:start
pnpm dev-server:watch`
const newApp = `pnpm gapp [new-app-name]`
const glib = `pnpm glib [namespace/new-lib-name]
example:
pnpm glib shared/ui-dob-select`
const gc = `pnpm gc [new-component-name] --project=[dahserized-project-name]
example:
pnpm gc dob-select --project=shared-ui-dob-select`
const elem = `pnpm gelem [new-element-name]
example:
pnpm gelem se-persona-picker`

@Component({
  selector: 'se-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  standalone: false,
})
export class HomeComponent {

  public code = {
    elem,
    gc,
    glib,
    newApp,
    start,
    startAll,
    startDev,
    startWatch
  }
}
